module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/react-tap-event-plugin/1.0.0/react-tap-event-plugin/src/defaultClickRejectionStrategy.js
 ** module id = 582
 ** module chunks = 0
 **/